// Dostopamo do coaches state v index.js. coaches array je nato exportan kot computed property (getter)

export default {
  coaches(state) {
    return state.coaches;
  },
// state() v index.js uporabimo kot value state
// hasCoaches getter uporabimo v primeru da je coaches array prazen
// rezultat je Boolean (TRUE če so coaches, FALSE če ni nobenega coacha (cooaches lenght > 0))
  hasCoaches(state) {
    return state.coaches && state.coaches.length > 0;
  },
  //// _ in _2 je konvencija, če moraš specificirat argument (value) ampak ga namerno izpustiš
  isCoach(_, getters, _2, rootGetters) {
    // pridobimo podatke iz getterjev in rootegeterjev ki jih spravimo v konstanti kateri bomo enačili v funkciji da dobimo logiran ID
    const coaches = getters.coaches;
    const userId = rootGetters.userId
    // .some je built in funkcija ki vrne TRUE če kakšen od coach zadosti kriterijem
    return coaches.some(coach => coach.id === userId)
    // isCoach je uporabljena v CoachesList, da nam prikaže ali skrije register button glede na to ali smo že registrirani ali ne
  }
};
